import { AiOutlineArrowRight, AiOutlineArrowLeft } from 'react-icons/ai';

const CustomLeftArrow = ({ onClick }) => (
    <button
      onClick={() => onClick()}
      className="custom-left-arrow"
      variant="contained"
      size="medium"
      color="primary"
      style={{
        position: "absolute",
        left: 0,
        backgroundColor: '#f37e21',
          width: '40px',
          height: '40px'
      }}
    >
      {/* <i className="icon-previous" style={{color: '#ffffff'}}></i> */}
      <AiOutlineArrowLeft style={{color: "white", width:"40px"}} />
    </button>
  );
  
  const CustomRightArrow = ({ onClick }) => {
    return (
      <button
        className="custom-right-arrow"
        onClick={() => onClick()}
        variant="contained"
        size="medium"
        color="primary"
        style={{
          position: "absolute",
          right: 0,
          backgroundColor: '#f37e21',
          width: '40px',
          height: '40px'
        }}
      >
        {/* <i className="icon-next" style={{color: '#ffffff'}}></i> */}
        <AiOutlineArrowRight style={{color: "white", width:"40px"}} />
      </button>
    );
  };
  
  export { CustomLeftArrow, CustomRightArrow };